// Utility
import styles from "../ProductSpotlight/ProductSpotlight.module.scss";
import { CustomEventLocation } from "../../helpers/GoogleTagManager/types/CustomEventLocation";
import { ProductCategory } from "../../helpers/GoogleTagManager/types/ProductCategory";
import { DataLayerConfig } from "../../helpers/GoogleTagManager/types/DataLayerConfig";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import spotlightImage from "./img/webp/spotlight-img.webp";

export default function ProductSpotlight() {
  const dataLayerConfig: DataLayerConfig = {
    location: CustomEventLocation.PRODUCT_SPOTLIGHT,
    productCategory: ProductCategory.CLASSROOM_DESIGN,
  };

  return (
    <div className={styles.wrapper}>
      <article className={styles.container}>
        <div className={styles.border}></div>
        <div className={styles.imgBGSquiggle}>
          <div className={styles.imgShadow}>
            <div className={styles.imgBorder}>
              <img
                className={styles.img}
                src={spotlightImage}
                alt="School children using stack and sit stools"
                width="800"
                height="586"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div className={styles.productInfo}>
          <p className={styles.productDesc}>
            Following 25 years of experience creating school playgrounds
          </p>
          <h3 className={styles.productTitle}>
            Discover our BRAND-NEW <br /> Indoor Classroom Furniture
          </h3>
          <div className={styles.ctaButton}>
            <PrimaryButton
              dataLayerConfig={dataLayerConfig}
              link="https://www.pentagonplay.co.uk/products/classroom-design"
              size="medium"
              text="View Range"
              buttonColor="#4677b8"
              hoverColor="#385f93"
            />
          </div>
        </div>
      </article>
    </div>
  );
}
